import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon, ArrowRightIcon, ClockIcon } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-20 bg-[#FDF8F4]" data-id="element-103">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        {/* Not for you / For you */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl border-l-4 border-gray-300 shadow-sm" data-id="element-106">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-107">
              ESTO NO ES PARA VOS SI…
            </h3>
            <ul className="space-y-3 text-gray-600" data-id="element-108">
              <li className="flex items-start gap-2" data-id="element-109">
                <span className="text-red-500 font-bold" data-id="element-110">✕</span> Buscás
                actividades sueltas
              </li>
              <li className="flex items-start gap-2" data-id="element-111">
                <span className="text-red-500 font-bold" data-id="element-112">✕</span> Querés recetas
                cerradas
              </li>
              <li className="flex items-start gap-2" data-id="element-113">
                <span className="text-red-500 font-bold" data-id="element-114">✕</span> No te importa
                registrar procesos
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl border-l-4 border-[#0D7377] shadow-sm" data-id="element-115">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-116">
              👉 SÍ ES PARA VOS SI...
            </h3>
            <p className="text-lg text-gray-700 font-medium" data-id="element-117">
              Querés trabajar con orden, criterio y tranquilidad profesional.
            </p>
          </motion.div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl p-8 mb-16 text-center border border-gray-100 shadow-sm max-w-2xl mx-auto" data-id="element-118">
          <ShieldCheckIcon className="w-12 h-12 text-[#0D7377] mx-auto mb-4" data-id="element-119" />
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-120">
            GARANTÍA 7 DÍAS
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-121">
            Probalo. Si no sentís más orden, claridad y seguridad clínica, te
            devolvemos el 100%.
          </p>
          <p className="font-bold text-[#0D7377]" data-id="element-122">El riesgo es nuestro.</p>
        </motion.div>

        {/* Purchase Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-123">
          <div className="bg-[#0D7377] p-4 text-center text-white font-bold tracking-wider text-sm uppercase" data-id="element-124">
            Oferta por tiempo limitado
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-125">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-126">
              MEGA PACK DE INTERVENCIÓN FONOAUDIOLÓGICA INFANTIL
            </h2>
            <p className="text-gray-500 mb-8" data-id="element-127">Acceso inmediato y de por vida</p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-128">
              <span className="text-2xl text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-129">
                ARS $49.990
              </span>
              <span className="text-5xl md:text-6xl font-extrabold text-[#E8614D]" data-id="element-130">
                ARS $19.990
              </span>
            </div>

            <motion.a href="https://maestros.ebookditales.com/cart/44768212975752:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(34, 197, 94, 0.7)', '0 0 0 10px rgba(34, 197, 94, 0)']
          }} transition={{
            boxShadow: {
              repeat: Infinity,
              duration: 1.5
            }
          }} className="block w-full bg-[#22C55E] text-white py-5 rounded-lg font-bold text-xl md:text-2xl shadow-lg hover:bg-[#16A34A] transition-colors mb-6 no-underline" data-id="element-131">
              Quiero trabajar con este sistema profesional
            </motion.a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-600" data-id="element-132">
              <div className="flex items-center gap-2" data-id="element-133">
                <CheckIcon className="w-4 h-4 text-[#0D7377]" data-id="element-134" />
                Acceso inmediato
              </div>
              <div className="flex items-center gap-2" data-id="element-135">
                <CheckIcon className="w-4 h-4 text-[#0D7377]" data-id="element-136" />
                Descarga digital
              </div>
              <div className="flex items-center gap-2" data-id="element-137">
                <CheckIcon className="w-4 h-4 text-[#0D7377]" data-id="element-138" />
                Herramienta profesional premium
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-4 text-center text-sm text-gray-500 border-t border-gray-100" data-id="element-139">
            Un sistema que te sostiene cuando el trabajo clínico pesa.
          </div>
        </motion.div>
      </div>
    </section>;
}